/**
 * Roles API
 */
import { apiClient } from "./client";
import { useQuery } from "@tanstack/react-query";

export interface Role {
    value: string;
    name: string;
}

/**
 * Fetches all available roles
 */
export const fetchRoles = async (): Promise<Role[]> => {
    const response = await apiClient.get<Role[]>("/roles");
    return response.data;
};

/**
 * React Query hook for fetching roles
 */
export const useRoles = () => {
    return useQuery({
        queryKey: ["roles"],
        queryFn: fetchRoles,
        staleTime: 60 * 60 * 1000, // 1 hour (roles don't change often)
    });
};